import { z } from 'zod'

export const monthEvaluationWorkerFormValidationSchema = z.object({
  worker_subtype_id: z
    .string()
    .min(1, 'Selecione o tipo de serviço para a analise'),
})

export type MonthEvaluationWorkerFormValues = z.infer<
  typeof monthEvaluationWorkerFormValidationSchema
>
